import { __ } from '../utils/i18n';

type TrialBannerProps = {
  subscriptionTierUrl: string;
};

const TrialBanner = ({ subscriptionTierUrl }: TrialBannerProps) => (
  <div className="acchub-trial-banner" role="status" aria-live="polite">
    <span className="acchub-trial-banner__text">{__('Vous êtes en essai gratuit.')}</span>
    <a href={subscriptionTierUrl} className="acchub-trial-banner__cta btn-white">
      {__('Choisir un abonnement')}
    </a>
  </div>
);

export default TrialBanner;
